module.exports = __webpack_public_path__ + "img/ISMT2.20012203.png";